import React, { useRef, useLayoutEffect } from "react";
import cx from "classnames";
import Rellax from "rellax";
import { ReactComponent as BGLinesSingle } from "../../images/svg/BGLinesSingle.svg";
import { ReactComponent as BGLinesDouble } from "../../images/svg/BGLinesDouble.svg";
import { ReactComponent as BGLinesMega } from "../../images/svg/BGLinesMega.svg";

import styles from "./background-lines.module.css";

function hasKey<O>(obj: O, key: keyof any): key is keyof O {
  return key in obj;
}

const BackgroundLinesSVG = ({ type }: { type: string }) => {
  switch (type) {
    case "single":
      return <BGLinesSingle />;
    case "double":
      return <BGLinesDouble />;
    case "mega":
      return <BGLinesMega />;
    default:
      return <div />;
  }
};

interface BackgroundLinesProps {
  type: string;
  color: string;
  alignment: string;
}
export const BackgroundLines = ({
  type,
  color,
  alignment
}: BackgroundLinesProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const rellax = new Rellax(ref.current, {
      speed: -2,
      center: true
    });
  }, [ref]);

  return (
    <div
      className={cx(
        styles.backgroundLinesContainer,
        hasKey(styles, type) && styles[type],
        hasKey(styles, alignment) && styles[alignment],
        hasKey(styles, color) && styles[color]
      )}
    >
      <div ref={ref} className={cx(styles.backgroundLines)}>
        <BackgroundLinesSVG type={type} />
      </div>
    </div>
  );
};
